import React from 'react';

interface ErrorMessageProps {
  message: string;
  onDismiss?: () => void;
}

export const ErrorMessage: React.FC<ErrorMessageProps> = ({ message, onDismiss }) => {
  return (
    <div className="relative flex min-h-screen items-center justify-center bg-surface overflow-hidden">
      {/* Ambient gradient blobs */}
      <div className="absolute -top-[20%] -left-[10%] w-[60%] h-[60%] bg-error/5 blur-[120px] rounded-full pointer-events-none" />
      <div className="absolute -bottom-[20%] -right-[10%] w-[50%] h-[50%] bg-[#007bba]/5 blur-[100px] rounded-full pointer-events-none" />

      {/* Content */}
      <div className="relative z-10 w-full max-w-md px-4">
        <div className="bg-surface-container-low rounded-xl p-8 space-y-6 shadow-2xl">
          {/* Icon */}
          <div className="flex justify-center">
            <div className="flex h-16 w-16 items-center justify-center rounded-full bg-error-container/30">
              <span
                className="material-symbols-outlined text-error text-4xl"
                style={{ fontVariationSettings: "'FILL' 1, 'wght' 400, 'GRAD' 0, 'opsz' 24" }}
              >
                error
              </span>
            </div>
          </div>

          {/* Title */}
          <div className="text-center space-y-2">
            <h2 className="text-xl font-bold text-on-surface">Something Went Wrong</h2>
            <p className="text-sm text-on-surface-variant leading-relaxed">{message}</p>
          </div>

          {/* Actions */}
          <div className="space-y-3">
            {onDismiss && (
              <button
                onClick={onDismiss}
                className="w-full flex items-center justify-center gap-2 rounded-lg bg-primary-container px-4 py-3 text-sm font-medium text-white hover:opacity-90 transition-opacity"
              >
                <span className="material-symbols-outlined text-lg">close</span>
                Dismiss
              </button>
            )}

            {/* Help text */}
            <p className="text-center text-[11px] text-on-surface-variant/60">
              Try refreshing the page or restarting the activity. If the issue persists, contact your server administrator.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};
